import * as React from 'react'
import * as Assets from '../../../assets/Assets'
import * as Utils from '../../../Logic/Utils'
// import { Main } from '../../../Logic/Main'
// import { Logic } from '../../../Logic/Type'
import { Link } from 'react-router-dom'
import { Cookies, withCookies } from 'react-cookie'
import Socket from '../../../Socket/socket-init'
import * as RouteClasses from '../../../Socket/route-classes'
import {Helmet} from 'react-helmet'

export function getMenu(className: string, menu: Assets.Menu[]): JSX.Element {
    let elements: JSX.Element[] = []
    for (let i = 0; i < menu.length; i++) {
        elements.push(
            <li key={i.toString()}>
                {(menu[i].content === 'LOGOUT') ?
                <Link to="/login" className="hide-logout" onClick={() => Utils.logout()}>{menu[i].content}</Link>
                :
                (menu[i].content === 'MY PROFILE') ?
                <Link to="/myprofile" className="hide-profile">{menu[i].content}</Link>
                :
                (menu[i].selector === 100) ?
                <Link to={menu[i].content.toLowerCase().replace(/\s/g, '')}>
                {menu[i].content}
                </Link>
                :
                <Link to={menu[i].content.toLowerCase().replace(/\s/g, '')}>
                {menu[i].content}
                </Link>}
            </li>
        )
    }

    return (<ul className={'nav navbar-nav ' + className}>{elements}</ul>)
}

export function getCards(title: string, content: string, icon: string | undefined, svg: string | undefined): JSX.Element {
    return (
        <div className="col-xs-4 block-lvl3">
            <div className="block-internal equal-height-col card-firstpage">
                {icon !== undefined ? <i className={icon} /> : void 0}
                {svg !== undefined ? <svg id="agrmnt" className="icon-agrmnt" viewBox="0 0 487.4 487.4"><g><path d={svg} fill="#33AA00" /></g></svg> : void 0}
                <div className="h4">{title}</div>
                <p>{content}</p>
            </div>
        </div>
    )
}

export function getThreeColumns(title: string, content: string[]): JSX.Element {
    let columns: JSX.Element[] = []
    columns.push(<label key={columns.length}>{title}</label>)
    for (const item of content) {
        columns.push(<p key={columns.length} className="text-left">{item}</p>)
    }

    return (<li>{columns}</li>)
}

interface IState {
    mobileMenu: boolean
    username: string
    password: string
    passwordConfirmation: string
    email: string
    checkbox: boolean
    subscription: boolean
    listen: boolean
}

class Body extends React.Component<{}, IState> {
    
    public cookies
    public intervalID
    
    constructor(props) {
        super(props)

        window.scroll(0, 0)

        this.cookies = new Cookies()

        this.state = this.getInitialState()

        Socket.Send('rounds', {playerId: 1})
    }

    getInitialState() {
        return {
            email: '',
            username: '',
            password: '',
            passwordConfirmation: '',
            mobileMenu: false,
            checkbox: false,
            subscription: false,
            listen: true
        }
    }

    handleInput(value: string, state: string) {
        Socket.Set('registration', {})
        this.state[state] = value
        this.setState(this.state)
    }

    sendUser() {
        if (this.state.username === '') {
            alert('Write your Username.')
        } else if (this.state.password === '') {
            alert('Write your Password.')
        } else if (this.state.email === '') {
            alert('Write your Email.')
        } else if (!this.state.checkbox) {
            alert('You have to agree to the Accumulator Club Terms of Service.')
        } else {
            if (this.state.password === this.state.passwordConfirmation) {
                const user: RouteClasses.IUser = {
                    firstName: '',
                    lastName: '',
                    email: this.state.email,
                    username: this.state.username,
                    password: this.state.password,
                    nationality: '',
                    subscription: this.state.subscription
                }
                Socket.Send('registration', user)
            } else {
                alert ('Passwords do not match.')
            }
        }
    }

    componentWillUnmount() {
        clearInterval(this.intervalID)
    }

    componentWillReceiveProps() {
        const rounds = Socket.Get<any>('rounds')
        
        const currentDate = new Date().getTime()
        if (this.state.listen && rounds.loading === 'loaded') {
            const allRounds = rounds.rounds
            const filteredRounds = allRounds.filter(elt => new Date(elt.deadline).getTime() > currentDate)

            if (filteredRounds.length > 0) {
                const firstDeadline = new Date(filteredRounds[0].deadline)
                const firstDeadlineMonth = firstDeadline.getMonth() + 1
                const firstDeadlineDay = firstDeadline.getDate()
                const firstDeadlineYear = firstDeadline.getFullYear()
                const firstDeadlineHours = firstDeadline.getHours()
                const firstDeadlineMinutes = firstDeadline.getMinutes()
                const dateString: string = 
                    firstDeadlineMonth + '/' + firstDeadlineDay + '/' + firstDeadlineYear + ' ' +
                    firstDeadlineHours + ':' + firstDeadlineMinutes + ':00 ' + ' UTC'
                const dateDeadline = new Date(dateString).getTime()

                this.intervalID = setInterval(function() {
                    const dateNow = new Date().getTime()
                    const distance = dateDeadline - dateNow
                    if (distance > 0) { 
                        const days = Math.floor(distance / (1000 * 60 * 60 * 24)) 
                        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
                        const minutes = Math.floor((distance % (1000 * 60 *60)) / (1000 * 60))
                        const seconds = Math.floor((distance % (1000 * 60)) / 1000)
                        document.getElementById('day').innerHTML = (days < 10) ? '<span>' + '0' + days.toString() + '</span>' : '<span>' + days.toString() + '</span>'
                        document.getElementById('hour').innerHTML = (hours < 10) ? '<span>' + '0' + hours.toString() + '</span>' : '<span>' + hours.toString() + '</span>'
                        document.getElementById('month').innerHTML = (minutes < 10) ? '<span>' + '0' + minutes.toString() + '</span>' : '<span>' + minutes.toString() + '</span>'
                        document.getElementById('second').innerHTML = (seconds < 10) ? '<span>' + '0' + seconds.toString() + '</span>' : '<span>' + seconds.toString() + '</span>'
                    } else {
                        document.getElementById('day').innerHTML = '<span>00</span>'
                        document.getElementById('hour').innerHTML = '<span>00</span>'
                        document.getElementById('month').innerHTML = '<span>00</span>'
                        document.getElementById('second').innerHTML = '<span>00</span>'
                    }
                }, 1000)

                this.setState({ listen: false })
            } else {
                this.intervalID = setInterval(function() {
                        document.getElementById('day').innerHTML = '<span>00</span>'
                        document.getElementById('hour').innerHTML = '<span>00</span>'
                        document.getElementById('month').innerHTML = '<span>00</span>'
                        document.getElementById('second').innerHTML = '<span>00</span>'
                    }, 1000)
                    
                this.setState({ listen: false })
            }
        }
    }

    render() {
        const registration = Socket.Get<any>('registration')
        if (registration.registration) {
            if (registration.registration.message === 'Username already exists.') alert('Username already exists.')
            if (registration.registration.message === 'Email already exists.') alert('Email already exists.')
            if (registration.registration.message === 'Both already exist.') alert('Username and email already exist.')
        }
        return (
            <div className="new-homepage mean-container">
                <Helmet>
                    <meta charSet="utf-8"/>
                    <title>The Accumulator Club – Premier League predictions – Join the club</title>
                    <meta 
                        name="description" 
                        content="The Accumulator Club is the ultimate punting championship, where users make a series
                        of football predictions across a number of different betting markets. Compete in private leagues and
                        overall rankings in this free to play football game with a cash prize up for grabs every gameweek –
                        Join the club!"
                    />
                </Helmet>
                <div className="mean-bar">
                    {(!this.state.mobileMenu) ? <a style={{ marginLeft: '15px', color: '#FFF', fontSize: '17px' }}>{this.cookies.get('username')}</a> : null}
                    <a 
                        className={(this.state.mobileMenu) ? 'meanmenu-reveal meanclose' : 'meanmenu-reveal'} 
                        style={(this.state.mobileMenu) ? {right: '0', left: 'auto', textAlign: 'center', textIndent: '0', fontSize: '18px'} : { right: '0', left: 'auto'}} 
                        onClick={() => this.setState({ mobileMenu: !this.state.mobileMenu })}
                    >
                        {(this.state.mobileMenu) ?
                        'X'
                        :
                        <div>
                            <span/>
                            <span/>
                            <span/>
                        </div>
                        }
                    </a>
                    <nav className="mean-nav">
                    <ul style={(this.state.mobileMenu) ? { display: 'block' } : { display: 'none' }}>
                        <li className="montserrat-medium"><Link to="/lounge">Lounge</Link></li>
                        <li className="montserrat-medium"><Link to="/howtoplay">HOW TO PLAY</Link></li>
                        <li className="montserrat-medium"><Link to="/leagues">LEAGUES</Link></li>
                        {(!this.cookies.get('username')) ? 
                        <div>
                            <li className="montserrat-medium"><Link to="/login">LOGIN</Link></li>
                            <li className="mean-last montserrat-medium"><Link to="/signup">SIGN UP</Link></li>
                        </div>
                        : null}
                    </ul>
                    </nav>
                </div>
        {/*[if lt IE 8]>
            <p className="browserupgrade">You are using an <strong>outdated</strong> browser. Please <a href="http://browsehappy.com/">upgrade your browser</a> to improve your experience.</p>
        <![endif]-->

        <!-- Add your site or application content here -->
        <!--  mobile menu-->*/}
                <div className="header-area sticky-nav">
                    <div className="container container-homepage">
                        <div className="row">
                            <div className="col-md-6">
                                <div className="main-menu">
                                    <ul>
                                        <li style={{ cursor: 'pointer' }}> <Link to="/lounge" className="montserrat-semi-bold">Lounge</Link> </li>
                                        <li style={{ cursor: 'pointer' }}> <Link to="/howtoplay" className="montserrat-semi-bold">HOW TO PLAY</Link> </li>
                                        <li style={{ cursor: 'pointer' }}> <Link to="/leagues"className="montserrat-semi-bold">LEAGUES</Link> </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-md-3 col-xs-12">
                                <div className="site-logo">
                                    <img src="logo-main2.png" alt="The Accumulator Club presents…"/>
                                </div>
                            </div>
                            {(!this.cookies.get('username')) ?
                            <div className="col-md-3">
                                <div className="user-login">
                                    <ul>
                                        <li className="montserrat-semi-bold"> <Link to="/login">LOGIN</Link> </li>
                                        <li className="montserrat-semi-bold"> <Link to="/signup">SIGN UP</Link> </li>
                                    </ul>
                                </div>
                            </div>
                            : 
                            <div className="col-md-3">
                                <div className="user-login">
                                    <ul>
                                        <li className="montserrat-semi-bold homepage-username"><a>{this.cookies.get('username')}</a></li>
                                    </ul>
                                </div>
                            </div>
                            }
                        </div>
                    </div>
                </div>

                <div className="hero-area">
                    <div className="container container-homepage">
                        <div className="row">
                            <div className="col-md-8 col-sm-12">
                                <div className="hero-inner">
                                    <h2 className="montserrat-extra-bold">The Accumulator Club presents…</h2>
                                    <div className="row">
                                        {(+screen.width < 500) ? <div className="clearfix"/> : null}
                                        <div className="col-md-8 col-sm-8 alternative-div">
                                            <div className="hero-big-text">
                                                <h1><span>the ultimate</span> Free to Play <br/> predictor! </h1>
                                                <h3 className="montserrat-extra-bold">#WHATSYOURSTRATEGY?</h3>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {!(this.cookies.get('username')) ?
                            <div className="col-md-4 col-sm-8 col-md-4-homepage">
                                <div className="form-box">
                                    <div className="form-box-inner">
                                        <h1 className="montserrat-extra-bold">Sign up now!</h1>
                                        <form className="form-main" action="contact.php" method="post">
                                            <input type="text" autoCapitalize="none" name="name" placeholder="Username" value={this.state.username} onChange={(event) => this.handleInput(event.target.value, 'username')} className="montserrat-medium"/>
                                            <input type="password" autoCapitalize="none" name="name" placeholder="Password" value={this.state.password} onChange={(event) => this.handleInput(event.target.value, 'password')} className="montserrat-medium"/>
                                            <input type="password" autoCapitalize="none" name="name" placeholder="Confirm password" value={this.state.passwordConfirmation} onChange={(event) => this.handleInput(event.target.value, 'passwordConfirmation')} className="montserrat-medium"/>
                                            <input type="email" autoCapitalize="none" name="name" placeholder="Email" value={this.state.email} onChange={(event) => this.handleInput(event.target.value, 'email')} className="montserrat-medium"/>
                                            <div className="form-group" style={{ marginTop: '10px', color: '#FFF' }}>
                                                <label className="checkbox-wrapper">
                                                    <input type="checkbox" checked={this.state.checkbox} onClick={() => this.setState({ checkbox: !this.state.checkbox })} />
                                                    <span className="checkbox-span"/>I Agree to the Accumulator Club
                                                    <Link to="/termsandconditions" className="btn-link"> Terms of Service </Link>
                                                    and 
                                                    <Link to="/privacypolicy" className="btn-link"> Privacy Policy. </Link>
                                                    I also confirm that I am at least 18 years of age.
                                                </label>
                                                <span className="error-block"><span>Error message</span></span>
                                            </div>
                                            <div className="form-group" style={{ marginTop: '10px', color: '#FFF' }}>
                                                <label className="checkbox-wrapper">
                                                    <input type="checkbox" checked={this.state.subscription} onClick={() => this.setState({ subscription: !this.state.subscription })} />
                                                    <span className="checkbox-span"/>
                                                    I would like to receive game updates, reminders and tips from The Accumulator Club (once a week).
                                                </label>
                                            </div>
                                            <div className="text-right">
                                                <button type="button" name="button" className="sub-btn" onClick={() => this.sendUser()}>
                                                    <img src="sub-btn.png" alt=""/>
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                            : null}
                        </div>
                    </div>

                    <div className="hero-bottom">
                        <div className="container container-homepage">
                            <div className="row">
                                <div className="col-md-4 col-sm-4 col-md-4-homepage no-float">
                                    <h1 className="montserrat-extra-bold">DEADLINE</h1>
                                    <h3 className="montserrat-extra-bold">FOR NEXT GAMEWEEK:</h3>
                                </div>

                                <div className="col-md-5 col-sm-6">
                                    <div className="coundown_res row">
                                        <div className="count">
                                            <div className="col-md-3 col-xs-3 col-sm-3">
                                                <h2 id="day">-</h2>
                                            </div>
                                        </div>
                                        <div className="count">
                                            <div className="col-md-3 col-xs-3 col-sm-3">
                                                <h2 id="hour">-</h2>
                                            </div>
                                        </div>
                                        <div className="count">
                                            <div className="col-md-3 col-xs-3 col-sm-3">
                                                <h2 id="month">-</h2>
                                            </div>
                                        </div>
                                        <div className="count">
                                            <div className="col-md-3 col-xs-3 col-sm-3">
                                                <h2 id="second">-</h2>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-3 col-sm-2">
                                    <button type="button" name="button" className="play-btn montserrat-extra-bold">
                                        <Link to="/lounge" style={{ color: '#FFF' }}>PLAY NOW!</Link>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="big-lenght-area">
                    <div className="container container-homepage">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="big-title">
                                    <h1><span>THE ULTIMATE PUNTING</span> CHAMPIONSHIP</h1>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-4 col-md-4-homepage">
                                <div className="big-area-text">
                                    <p className="montserrat-medium">Our Triple Threat game format combines multiple betting markets and punting disciplines.</p>
                                    <p className="montserrat-medium">Every round, users make 9 predictions across 3 betting criteria…</p>
                                </div>
                            </div>
                            <div className="col-md-8">
                                <div className="big-area-img">
                                    <img src="mobile-text.png" alt="mobile-text"/>
                                </div>
                            </div>
                        </div>

                        <div className="row pad_100">
                            <div className="col-md-6">
                                <div className="big-area-text">
                                    <h1>#WHATSYOURSTRATEGY?</h1>
                                    <h2 className="montserrat-extra-bold">Our unique points system is </h2>
                                    <h2 className="montserrat-extra-bold"> <strong>based on sportsbook odds</strong> </h2>
                                    <h3 className="montserrat-extra-bold">In each discipline, points for your correct selections are multiplied, just like an accumulator!</h3>
                                    <h2 className="montserrat-extra-bold"> <strong className="up_text">So how will you play?</strong> </h2>
                                    <h3 className="montserrat-extra-bold">Safe and consistent, or will you throw in a couple of punts and aim for the big time!?</h3>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="big-area-img">
                                    <img src="chart.png" alt="chart"/>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="big-title">
                                    <h1><span>POINTS</span> MEAN PRIZES</h1>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-4-homepage col-sm-3">
                                <div className="single_ser">
                                    <img src="img-1.png" alt="img-1"/>
                                    <p className="montserrat-medium">Create private leagues and compete with friends and colleagues to be the top punter</p>
                                </div>
                            </div>
                            <div className="col-md-4-homepage col-sm-3">
                                <div className="single_ser">
                                    <img src="img-3.png" alt="img-1"/>
                                    <p className="montserrat-medium">Track their progress and share your highlights</p>
                                </div>
                            </div>
                            <div className="col-md-4-homepage col-sm-3">
                                <div className="single_ser">
                                    <img src="img-2.png" alt="img-1"/>
                                    <p className="montserrat-medium">The overall winner of every round will win a cash prize</p>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>
                <div className="big-two">
                    <div className="container container-homepage">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="big-title">
                                    <h1><span>INTEGRATED</span>  STATS</h1>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-3">
                                <div className="big-area-text">
                                    <p className="montserrat-medium">During the selection process you can check team form, recent results and key stats</p>
                                    <p className="montserrat-medium">When picking anytime gaolscorers you can also access the statistics you need to make those vital decisions</p>
                                    <p className="montserrat-medium">Now you´re armed with the stats, you could even back your instinct with a flutter at the bookies!</p>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="big-area-img mat_top">
                                    <img src="gold-scor.png" alt="chart"/>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="big-area-img mat_top_2">
                                    <img src="scror-2.png" alt="chart"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="footer">
                    <div className="container container-homepage">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="footer_inner">
                                    <img src="logo-footer.png" alt=""/>
                                    <div className="big-title">
                                        <h1><span>join the social betting </span>  revolution!</h1>
                                    </div>
                                    <button type="button" name="button" className="play-btn montserrat-extra-bold">
                                        <Link to="/lounge" style={{ color: '#FFF' }}>PLAY NOW!</Link>
                                    </button>
                                    <h3 className="montserrat-extra-bold">Keep in touch with us!</h3>
                                    <ul>
                                        <li><a href="https://www.facebook.com/accumulatorclub/" target="_blank"><img src="facebook.png" alt=""/></a></li>
                                        <li><a href="https://twitter.com/theaccaclub" target="_blank"><img src="twitter.png" alt=""/></a></li>

                                    </ul>
                                    <p className="montserrat-medium">
                                        All games offered on The Accumulator Club are free to play, with cash prizes. The Accumulator Club 
                                        does not offer gambling facilities, although we may link to third party sites that do. Use of any 
                                        third party website is at your own risk and we will not be liable for any losses or damages. For 
                                        more information, please consult our terms of service and privacy policy.
                                    </p>
                                    <p>&copy;{' ' + Assets.productYear + ' ' + Assets.productOwner + '. All Rights Reserved.'}</p>
                                    <div className="powered-by-gamanza" style={{ justifyContent: 'center' }}>
                                        <img src={Assets.poweredByGamanzaBlack}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {(registration.registration && registration.registration.message === 'Registration successful.') ? this.showPopup() : null}
            </div>
        )
    }

    showPopup(): JSX.Element {
        const screenPosition = document.documentElement.scrollTop + 150
        const top = screenPosition.toString() + 'px'
        return (
            <div className="popup">
                <div className="popup-inner popup-forgot" style={{ top }}>
                    <div style={{ textAlign: 'right', marginBottom: '10px' }}>
                        <img onClick={() => {Socket.Set('registration', {}), this.setState(this.getInitialState())}} style={{ cursor: 'pointer' }} src="cancel-black.png" />
                    </div>
                    <div className="fist-bump"><img src="fist-bump.svg"/></div>
                    <p className="congratulations-first">Well played!</p>
                    <p className="congratulations-second">Your sign up has been received...</p>
                    <p className="congratulations-third">Please check your email inbox (and perhaps your spam) - We have sent you an email with a link to verify your email address.</p>
                </div>
            </div>
        )
    }
}

export default withCookies(Body)


// WEBPACK FOOTER //
// ./src/Views/Main/Index/Body.tsx